import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  fields: string[];
  translatedMessage: string;
  selectedTabIndex: number;
  chargeTemplates: any[];
}

const initialState: StateInterface = {
  isFetching: false,
  fields: [],
  translatedMessage: "",
  selectedTabIndex: 0,
  chargeTemplates: []
};

export const unitDefaultChargeTemplatesReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_CLEAR:
    case Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_CLEAR:
    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
